import { useRef, useState, useImperativeHandle, forwardRef } from 'react'

import styles from './../../pages/04_upload/uploadPage.module.scss'

import { v4 as uuidV4 } from 'uuid'
import { CancelEventArgs, UploaderComponent, UploadingEventArgs, ButtonsPropsModel } from '@syncfusion/ej2-react-inputs'
import { useOidcAccessToken } from '@axa-fr/react-oidc'
import { protectedResources } from '../../global/config.tsx'
import { fetchDataFromApi } from '../../services/fetchDataFromApi.tsx'

interface UploadComponentProps {
  autoUpload?: boolean;
  buttonList?: ButtonsPropsModel;
}

export interface UploadComponentHandle {
  startUpload: () => void;
}

const UploadComponent = forwardRef<UploadComponentHandle, UploadComponentProps>(({ autoUpload = false, buttonList = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' } }, ref) => {
  const [uploadUuId, setUploadUuid] = useState<string>()
  const { accessToken } = useOidcAccessToken()
  const uploadcmp = useRef<UploaderComponent>(null)

  const path = {
    chunkSize: 102400,
    retryAfterDelay: 3000,
    retryCount: 5,
    saveUrl: protectedResources.apiList.videoUpload,
  }

  const onUploadBegin = (args: UploadingEventArgs) => {
    const id = uuidV4()
    setUploadUuid(id)
    args.customFormData = [{ folderName: id }, { mimeType: (args.fileData.rawFile as Blob).type }]
    if (args.currentRequest) {
      args.currentRequest.setRequestHeader('Authorization', `Bearer ${accessToken}`)
    }
  }

  const onChunkUploadBegin = (args: UploadingEventArgs) => {
    if (uploadUuId) {
      args.customFormData = [{ folderName: uploadUuId }]
      if (args.currentRequest) {
        args.currentRequest.setRequestHeader('Authorization', `Bearer ${accessToken}`)
      }
    }
  }

  const onCanceling = (args: CancelEventArgs) => {
    if (uploadUuId) {
      args.customFormData = [{ folderName: uploadUuId }]
      const removeUrl = `${protectedResources.apiList.videoUploadRemove}/${uploadUuId}`
      fetchDataFromApi(removeUrl, accessToken, 'POST', 'json').then((res) => {
        if (res.status === 200) {
          return
        } else {
          args.cancel = true
        }
      })
    }
  }

  useImperativeHandle(ref, () => ({
    startUpload() {
      uploadcmp.current?.upload()
    },
  }))
  return (

    <UploaderComponent
      ref={uploadcmp}
      cssClass={styles.eUploadedFiles}
      buttons={buttonList}
      autoUpload={autoUpload}
      asyncSettings={path}
      maxFileSize={5000000000}
      allowedExtensions=".pptx, *.docx, *.pdf, *.xlsx"
      removing={onCanceling}
      uploading={onUploadBegin}
      chunkUploading={onChunkUploadBegin}
      sequentialUpload={true}
      multiple={true}
    />

  )
})

export default UploadComponent
